import React from 'react';
import { Outlet } from 'react-router-dom';
import SideNavBar from "../components/General/SideNavBar";
import Header from "../components/General/Header";

const PrivateLayout = ({children}) => {
    return (
        <div data-testid={"privateDiv"} className="d-flex" style={{backgroundColor: "rgba(217, 217, 217, 0.30)"}}>
            <div>
                <SideNavBar />
            </div>
            <div style={{flex:"1 1 auto", display:"flex", flexFlow:"column", overflowY:"hidden"}}>
                <Header />
                {children}
                <Outlet />
            </div>
        </div>
    )
}

export default PrivateLayout;